import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LeadCallOverViewReportService {


  constructor(private http: HttpClient) { }

  url = environment.serverAPI4 + "/api/leadCallOverViewReport";

  url2 = environment.serverAPI4 + "/api/leadCallSummaryReport";

  url3 = environment.serverAPI4 + "/api/leadMissedCallCount";

  LeadCallOverViewReport(query: string, page: number, size: number, sort: string, groupBy: any): Observable<Response[]> {

    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null,
      "groupBy": groupBy

    };

    const queryParams = `?page=${page}&size=${size}&sort=${sort}`;

    return this.http.post<Response[]>(`${this.url}/condition${queryParams}`, requestBody);
  }

  LeadCallSummaryReport(query: string, page: number, size: number, sort: string): Observable<Response[]> {

    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null,

    };

    const queryParams = `?page=${page}&size=${size}&sort=${sort}`;

    return this.http.post<Response[]>(`${this.url2}/condition${queryParams}`, requestBody);
  }

  LeadCallSummaryReportDynamic(query: string, metrics: string[]): Observable<any> {
    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null,
      "metrics": metrics
    };
    return this.http.post<any>(`${this.url2}Dynamic/condition`, requestBody);
  }

  leadMissedCallCount(query: string, page: number, size: number, sort: string): Observable<Response[]> {

    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null,

    };

    const queryParams = `?page=${page}&size=${size}&sort=${sort}`;

    return this.http.post<Response[]>(`${this.url3}/condition${queryParams}`, requestBody);
  }

}
